import { TEAMS_ACTIONS } from "../../constants/actionsConstants";

const initialState = {
  teams: [],
  loading: false,
  error: null
};

const teamReducer = (state = initialState, action) => {
  switch (action.type) {
    case TEAMS_ACTIONS.TEAMS_LOADING_START:
      return {
        ...state,
        loading: true,
        error: null
      };
    case TEAMS_ACTIONS.SET_ALL_TEAMS:
      return {
        ...state,
        teams: action.data?.teams || [],
        loading: false,
        error: null
      };
    case TEAMS_ACTIONS.TEAMS_LOADING_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case TEAMS_ACTIONS.TEAMS_ALREADY_LOADED:
      return {
        ...state,
        loading: false,
        error: null
      };
    default:
      return state;
  }
};

export default teamReducer;
